/* Bricks and Hits – Theme-Skript */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2200);
  }
  function money(cents) {
    var fmt = (window.BH && BH.moneyFormat) || 'CHF {{amount}}';
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  /* 3D-Tilt-Karten */
  function tilt(card) {
    if (!card || card.dataset.tiltInit) return;
    card.dataset.tiltInit = '1';
    if (!reduce) {
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--ry', ((x - 0.5) * 30) + 'deg');
        card.style.setProperty('--rx', ((0.5 - y) * 30) + 'deg');
        card.style.setProperty('--mx', (x * 100) + '%');
        card.style.setProperty('--my', (y * 100) + '%');
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
      });
    }
    card.addEventListener('click', function () { card.classList.toggle('flipped'); });
  }
  document.querySelectorAll('.tcard').forEach(tilt);

  /* Tabs (Hits der Woche) */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on);
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  });

  /* Warenkorb-Zähler */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n < 1;
    });
  }

  /* Schnell in den Warenkorb (Produktkarten + Produktseite) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'Fehler');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        toast((window.BH && BH.t.added) || 'Im Warenkorb');
        if (btn) btn.textContent = '✓';
      })
      .catch(function (err) { toast(err.message); if (btn) btn.textContent = label; })
      .finally(function () {
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1400);
      });
  });

  /* Mengenfelder */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + parseInt(b.dataset.qty, 10);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Warenkorb-Seite: Menge sofort speichern */
  document.querySelectorAll('[data-cart-line]').forEach(function (input) {
    input.addEventListener('change', function () {
      var body = { line: parseInt(input.dataset.cartLine, 10), quantity: parseInt(input.value, 10) || 0 };
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function () { window.location.reload(); });
    });
  });

  /* Reels: Vorschau beim Hover */
  document.querySelectorAll('.reel').forEach(function (reel) {
    var v = reel.querySelector('video');
    if (!v) {
      if (reel.getAttribute('href') === '#') reel.addEventListener('click', function (e) { e.preventDefault(); });
      return;
    }
    v.muted = true; v.playsInline = true; v.loop = true;
    reel.addEventListener('mouseenter', function () { if (!reduce) { v.play().catch(function () {}); reel.classList.add('playing'); } });
    reel.addEventListener('mouseleave', function () { v.pause(); reel.classList.remove('playing'); });
    reel.addEventListener('click', function (e) {
      if (reel.hasAttribute('data-external')) return;
      e.preventDefault();
      if (v.paused) { v.muted = false; v.play(); reel.classList.add('playing'); } else { v.pause(); reel.classList.remove('playing'); }
    });
  });

  /* Stream-Erinnerungen (nur im eigenen Browser) */
  document.querySelectorAll('.remind').forEach(function (b) {
    var key = 'bh-remind-' + b.dataset.key, on = false;
    try { on = localStorage.getItem(key) === '1'; } catch (e) {}
    function paint() { b.setAttribute('aria-pressed', on); b.textContent = on ? b.dataset.on : b.dataset.off; }
    paint();
    b.addEventListener('click', function () {
      on = !on; try { localStorage.setItem(key, on ? '1' : '0'); } catch (e) {}
      paint();
    });
  });

  /* Mobile-Menü */
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var bd = document.querySelector('.drawer-backdrop');
    function set(open) {
      panel.hidden = !open; if (bd) bd.hidden = !open;
      btn.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }
    btn.addEventListener('click', function () { set(panel.hidden); });
    if (bd) bd.addEventListener('click', function () { set(false); });
    panel.querySelectorAll('[data-drawer-close]').forEach(function (c) { c.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) set(false); });
  });

  /* Header-Dropdowns: Hover am Desktop, Tippen am Touchscreen */
  document.querySelectorAll('nav.main .has-drop').forEach(function (li) {
    var b = li.querySelector('.drop-btn');
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !li.classList.contains('open');
      document.querySelectorAll('nav.main .has-drop.open').forEach(function (o) { o.classList.remove('open'); o.querySelector('.drop-btn').setAttribute('aria-expanded', 'false'); });
      li.classList.toggle('open', open); b.setAttribute('aria-expanded', open);
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('nav.main .has-drop.open').forEach(function (o) { if (!o.contains(e.target)) { o.classList.remove('open'); o.querySelector('.drop-btn').setAttribute('aria-expanded', 'false'); } });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('nav.main .has-drop.open').forEach(function (o) { o.classList.remove('open'); });
  });

  /* Produktseite: Varianten, Galerie, 3D */
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) {
    var data = JSON.parse(pdp.querySelector('[data-variants]').textContent);
    var idInput = pdp.querySelector('input[name="id"]');
    var priceEl = pdp.querySelector('[data-price]');
    var buyBtn = pdp.querySelector('[data-buy]');
    var stockEl = pdp.querySelector('[data-stock]');

    function currentOptions() {
      return Array.prototype.map.call(pdp.querySelectorAll('[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function update() {
      var opts = currentOptions();
      var v = data.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) { buyBtn.disabled = true; buyBtn.textContent = BH.t.unavailable; return; }
      idInput.value = v.id;
      priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '');
      buyBtn.disabled = !v.available;
      buyBtn.textContent = v.available ? BH.t.addToCart : BH.t.soldOut;
      if (stockEl) stockEl.textContent = v.available ? BH.t.inStock : BH.t.soldOut;
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
      if (v.featured_media_id) showMedia(String(v.featured_media_id));
    }
    pdp.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', update); });

    var slides = pdp.querySelectorAll('[data-media-id]');
    var thumbs = pdp.querySelectorAll('[data-thumb]');
    function showMedia(id) {
      var found = false;
      slides.forEach(function (s) { var on = s.dataset.mediaId === id; s.hidden = !on; if (on) found = true; });
      if (!found && slides[0]) slides[0].hidden = false;
      thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.thumb === id); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.thumb); }); });

    /* Bild-Neigung beim Hover */
    pdp.querySelectorAll('.zoomable').forEach(function (img) {
      if (reduce) return;
      var box = img.parentElement;
      box.addEventListener('pointermove', function (e) {
        var r = box.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        img.style.transform = 'rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 14) + 'deg) scale(1.04)';
      });
      box.addEventListener('pointerleave', function () { img.style.transform = ''; });
    });

    var mvLoaded = false;
    function loadModelViewer() {
      if (mvLoaded) return; mvLoaded = true;
      Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function (err) {
        if (err) return;
        pdp.querySelectorAll('model-viewer').forEach(function (m) { new Shopify.ModelViewerUI(m); });
      } }]);
    }
    if (pdp.querySelector('[data-model]') && window.Shopify && Shopify.loadFeatures) loadModelViewer();
    if (window.location.hash === '#3d') {
      var m = pdp.querySelector('[data-model]');
      if (m) showMedia(m.dataset.mediaId);
    }
  }
})();
